/**
 * Composant de protection de route
 * 
 * Protège les routes nécessitant une authentification
 * - Affiche "Chargement..." pendant la vérification de session
 * - Redirige vers /auth si non authentifié
 * - Affiche les enfants si authentifié
 */

import React, { useLayoutEffect } from 'react';
import { useAuth } from '../contexts/AuthContext.jsx';
import { scrollToPageTop } from './ScrollToTop.jsx';

export default function ProtectedRoute({ children }) {
  const { loading, isAuthenticated } = useAuth();

  useLayoutEffect(() => {
    if (loading || !isAuthenticated) return undefined;

    scrollToPageTop();
    const timeoutIds = [60, 180, 360, 700].map((delay) => window.setTimeout(scrollToPageTop, delay));

    return () => {
      timeoutIds.forEach((timeoutId) => window.clearTimeout(timeoutId));
    };
  }, [loading, isAuthenticated]);

  // Pendant le chargement, afficher un état de chargement
  if (loading) {
    return (
      <div
        style={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontFamily: 'Inter, sans-serif',
          color: '#4b5563',
        }}
      >
        <div style={{ textAlign: 'center' }}>
          <div style={{ fontSize: '16px', marginBottom: '8px' }}>Chargement…</div>
          <div style={{ fontSize: '14px', color: '#6b7280' }}>Vérification de la session…</div>
        </div>
      </div>
    );
  }

  // Si non authentifié, rediriger vers /auth
  if (!isAuthenticated) {
    window.location.replace("/auth");
    return null;
  }

  // Si authentifié, afficher les enfants
  return children;
}
